import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Room cleaning & sanitization",
  "Linen & towel services",
  "Bathroom maintenance",
  "Reception & check-in support",
  "Kitchen operations",
  "Meal preparation & serving",
  "Dining area management",
  "Laundry services",
  "Inventory control",
  "Furniture & fixture upkeep",
  "Common area cleaning",
  "Security coordination"
];

const steps = [
  {
    number: "01",
    title: "Requirement Analysis",
    desc: "Understand guest house size, capacity, service expectations, and operational needs.",
  },
  {
    number: "02",
    title: "Team Deployment",
    desc: "Deploy hospitality-trained staff including housekeepers, front desk, and kitchen personnel.",
  },
  {
    number: "03",
    title: "Daily Operations",
    desc: "Manage all aspects of guest house operations with focus on cleanliness and service.",
  },
  {
    number: "04",
    title: "Quality Monitoring",
    desc: "Regular inspections, guest feedback, and continuous service improvement.",
  },
];

const GuestHouseServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Guest House Management Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default GuestHouseServices;
